<sh-card>
  <span header>{{ 'chat' | translate }}</span>
  <sh-loading-indicator
    *ngIf="loading"
    class="d-block text-center"
  ></sh-loading-indicator>
  <ng-container *ngIf="!loading">
    <ng-container
      *ngIf="
        messages && messages.length > 0;
        then showMessages;
        else noMessages
      "
    ></ng-container>
    <ng-template #showMessages>
      <div class="message-container">
        <div #observerTarget *ngIf="moreMessages" class="text-center">
          <small>{{ 'shared.terms.loadMore' | translate }}</small>
        </div>
        <div
          #messages
          class="m-3 d-flex align-items-start message"
          *ngFor="let message of messages"
        >
          <div
            *ngIf="!message.myMessage"
            class="py-2 px-2 mr-3 flex-shrink-0 text-center message-sender"
          >
            <span>{{ message.fromName | shInitials }}</span>
          </div>

          <div *ngIf="message.myMessage" class="flex-grow-1"></div>

          <div
            class="p-2 message-text"
            [ngClass]="{
              'my-message-bg': message.myMessage,
              'mr-5': !message.myMessage,
              'ml-5': message.myMessage
            }"
          >
            <span>{{ message.plainTextBody }}</span>
            <small class="text-muted d-block mt-1"
              >{{ message.createdOn | date: 'short' }},
              {{ message.fromName }}</small
            >
          </div>
        </div>
      </div>
    </ng-template>
    <ng-template #noMessages>
      <div class="card-body text-muted text-center">
        {{ 'chat.empty' | translate }}
      </div>
    </ng-template>
  </ng-container>
  <div footer class="d-flex mb-3 ml-3 mr-3">
    <input
      type="text"
      class="form-control mr-2"
      placeholder="{{ 'chat.add' | translate }}"
      [(ngModel)]="message"
      name="message"
    />
    <button class="btn btn-primary" (click)="add()" [disabled]="loading">
      {{ 'shared.terms.send' | translate }}
    </button>
  </div>
</sh-card>
